export const ADD_STUDIOS = 'CASINO.ADD_STUDIOS';
export const REMOVE_STUDIOS = 'CASINO.REMOVE_STUDIOS';
